export const CATEGORIES = {
  pdf_office: {
    id: 'pdf_office',
    label: 'PDF & Office',
    tileClass: 'tile-blue',
    catClass: 'pdf_office',
  },
  pdf_images: {
    id: 'pdf_images',
    label: 'PDF & Images',
    tileClass: 'tile-pink',
    catClass: 'pdf_images',
  },
  image_convert: {
    id: 'image_convert',
    label: 'Image Converters',
    tileClass: 'tile-green',
    catClass: 'image_convert',
  },
  utilities: {
    id: 'utilities',
    label: 'PDF Utilities',
    tileClass: 'tile-orange',
    catClass: 'utilities',
  },
};

import {
  FilePdf, FileDoc, FileXls, FilePpt, FileText,
  FileImage, Images, ArrowsClockwise,
  ArrowsMerge, ArrowsSplit, ArrowsInSimple, ArrowClockwise,
  FileArrowDown, Lock, LockOpen, Stamp, Scan, Package, PencilLine, PenNib, Scissors,
} from '@phosphor-icons/react';

export const TOOL_ICONS = {
  'pdf-to-word': FileDoc,
  'pdf-to-excel': FileXls,
  'pdf-to-powerpoint': FilePpt,
  'pdf-to-text': FileText,
  'word-to-pdf': FilePdf,
  'excel-to-pdf': FilePdf,
  'powerpoint-to-pdf': FilePdf,
  'text-to-pdf': FilePdf,
  'pdf-to-jpg': FileImage,
  'pdf-to-png': FileImage,
  'jpg-to-pdf': FilePdf,
  'png-to-pdf': FilePdf,
  'images-to-pdf': Images,
  'image-to-png': ArrowsClockwise,
  'image-to-jpg': ArrowsClockwise,
  'image-to-webp': ArrowsClockwise,
  'image-to-bmp': ArrowsClockwise,
  'image-to-gif': ArrowsClockwise,
  'merge-pdf': ArrowsMerge,
  'split-pdf': ArrowsSplit,
  'compress-pdf': ArrowsInSimple,
  'rotate-pdf': ArrowClockwise,
  'protect-pdf': Lock,
  'unlock-pdf': LockOpen,
  'watermark-pdf': Stamp,
  'ocr-pdf': Scan,
  'smart-compress': Package,
  'grammar-correct': PencilLine,
  'sign-pdf': PenNib,
  'remove-pages': Scissors,
};

export const FALLBACK_ICON = FileArrowDown;
